export const SelectAllHotkeys = 'ctrl+s, command+s';
